<!-- Header -->
<header>
  <div class="header-container">
    <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" />
    <nav>
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <ng-container *ngIf="isLoggedIn; else loginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="router.navigate(['/appointments'])">
          My Appointments
        </a>
      </ng-container>
      <ng-template #loginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="login()">Login / Signup</a>
      </ng-template>
    </nav>
    <button class="mobile-menu-btn" (click)="toggleMobileMenu()">☰</button>
  </div>
  <div class="mobile-menu" [class.active]="mobileMenuOpen" id="mobileMenu">
    <nav class="mobile-nav">
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <ng-container *ngIf="isLoggedIn; else mobileLoginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="mobileMenuOpen = false; router.navigate(['/appointments'])">
          My Appointments
        </a>
      </ng-container>
      <ng-template #mobileLoginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="mobileMenuOpen = false; login()">Login / Signup</a>
      </ng-template>
    </nav>
  </div>
</header>

<div class="upload-overlay" *ngIf="isLoading">
  <div class="logo-spinner">
    <img src="assets/logo.svg" alt="Loading..." />
  </div>
</div>

<div class="search-results-page">
  <!-- Search Bar Section -->
  <section class="search-bar-section">
    <div class="search-bar-container">
      <form class="search-filters" (ngSubmit)="onApplyFilters()">
        <div class="filter-group">
          <label>Location</label>
          <div class="search-icon">
            <i class="bi bi-geo-alt"></i>
            <input type="text" class="filter-input" [(ngModel)]="filters.location" name="location" placeholder="Search by Location">
          </div>
        </div>
        <div class="filter-group">
          <label>Practice Areas</label>
          <div style="position: relative;">
            <input
              type="text"
              class="filter-input"
              [(ngModel)]="filters.searchQuery"
              name="searchQuery"
              placeholder="Divorce law, Property law"
              (focus)="onSearchFocus()"
              (input)="onSearchInput($event)"
              (blur)="onSearchBlur()"
              autocomplete="off">
            <div class="specialization-dropdown" *ngIf="showSpecializationDropdown">
              <div class="specialization-item" *ngFor="let spec of filteredSpecializations" (mousedown)="selectSpecialization(spec)">
                <i class="bi bi-search"></i>
                <span>{{ spec.name }}</span>
              </div>
              <div class="specialization-item no-results" *ngIf="filteredSpecializations.length === 0">
                No results found
              </div>
            </div>
          </div>
        </div>
        <button type="submit" class="filter-btn">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 20 20">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
          Search
        </button>
      </form>
    </div>
  </section>

  <!-- Results Container -->
  <div class="results-container">
    <div class="results-wrapper">
      <section class="results-section" #resultsList>
        <div class="results-header" *ngIf="!isLoading">
          <h2>{{ totalCount }} {{ hasAnyFirm ? 'Results' : 'Lawyers' }} Found</h2>
        </div>

        <!-- ── LOOP: render firm card OR lawyer card based on isFirm ── -->
        <ng-container *ngIf="!isLoading">
        <ng-container *ngFor="let item of lawyers">

          <!-- ════════════════════════════════════════
               FIRM CARD (isFirm === true)
               ════════════════════════════════════════ -->
          <div class="firm-card" *ngIf="item.isFirm; else lawyerCard">
            <!-- <div class="firm-card-accent"></div> -->

            <div class="firm-card-body">
              <!-- Left: Avatar / Icon -->
              <div class="firm-avatar-container">
                <ng-container *ngIf="item.avatar && item.avatar !== ''; else firmIconFallback">
                  <img [src]="item.avatar" [alt]="item.name + ' Profile Picture'" class="firm-avatar-img" loading="lazy" />
                </ng-container>
                <ng-template #firmIconFallback>
                  <div class="firm-avatar-icon">
                    <i class="bi bi-building"></i>
                  </div>
                </ng-template>
              </div>

              <!-- Middle: Info -->
              <div class="firm-info">
                <div class="firm-name-row">
                  <span class="firm-name firm-name-link" (click)="viewFirm(item)">{{ item.name }}</span>
                  <span class="firm-badge">Law Firm</span>
                </div>
                
                <div class="firm-specializations" *ngIf="item.specializations?.length">
                  <span class="spec-text">
                    {{ formatSpecializationsWithMore(item.specializations) }}
                  </span>
                  <span class="spec-more-inline" *ngIf="item.specializations.length > 5">
                    +{{ item.specializations.length - 5 }} more
                  </span>
                </div>

                <div class="firm-meta-row">
                  <div class="firm-meta-item" *ngIf="item.experience">
                    <i class="bi bi-briefcase"></i>
                    <span>{{ item.experience }} years exp</span>
                  </div>
                  <div class="firm-meta-item" *ngIf="item.location">
                    <i class="bi bi-geo-alt"></i>
                    <span>{{ item.location }}</span>
                  </div>
                  <div class="firm-meta-item" *ngIf="item.memberCount">
                    <i class="bi bi-people"></i>
                    <span>{{ item.memberCount }} Lawyer{{ item.memberCount !== 1 ? 's' : '' }}</span>
                  </div>
                </div>
              </div>

              <!-- Right: CTAs -->
              <div class="firm-cta-section">
                <span class="availability-badge" [ngStyle]="item.availabilityStyle"
                  [ngClass]="{'badge-unavailable': item.availability === 'Unavailable'}">
                  {{ item.availability }}
                </span>
                <button class="book-btn"
                  [disabled]="item.availability === 'Unavailable' || loadingFirmId === (item.firmId || item.id)"
                  (click)="bookSlot(item); $event.stopPropagation()"
                   [title]="item.availability === 'Unavailable' ? 'This lawyer is currently unavailable' : 'Book an appointment'"
                  [attr.data-tooltip]="item.availability === 'Unavailable' ? 'This lawyer is currently unavailable' : ''">
                  {{ loadingFirmId === (item.firmId || item.id) ? 'Loading...' : 'Book Appointment' }}
                </button>
              </div>
            </div>
          </div>

          <!-- ════════════════════════════════════════
               EXISTING LAWYER CARD (isFirm === false / undefined)
               ════════════════════════════════════════ -->
          <ng-template #lawyerCard>
            <div class="lawyer-card">
              <div class="avatar-container">
                <ng-container *ngIf="item.avatar && item.avatar !== ''; else noAvatar">
                  <img [src]="item.avatar" [alt]="getFirstName(item.name) + ' Profile Picture'" class="lawyer-avatar" loading="lazy" />
                </ng-container>
                <ng-template #noAvatar>
                  <div class="avatar-placeholder">{{ getFirstNameChar(item.name) }}</div>
                </ng-template>
              </div>

              <div class="lawyer-info">
                <div class="lawyer-name-section">
                  <span class="lawyer-name">{{ item.name }}</span>
                </div>
                <div class="lawyer-specialty">
                  {{ formatSpecializationsWithMore(item.specializations) }}
                  <span class="spec-more-inline" *ngIf="item.specializations.length > 5">
                    +{{ item.specializations.length - 5 }} more
                  </span>
                </div>
                <div class="lawyer-meta" >
                  <div *ngIf="item.experience"><i class="bi bi-briefcase"></i> {{ item.experience }} years exp</div>
                  <div class="meta-item">
                    <i class="bi bi-geo-alt"></i> {{ item.location }}
                  </div>
                </div>
                <div class="lawyer-languages" *ngIf="item.languages">
                  <i class="bi bi-translate"></i> {{ item.languages }}
                </div>
              </div>

              <div class="card-right-section">
                <span class="availability-badge" [ngStyle]="item.availabilityStyle"
                  [ngClass]="{'badge-unavailable': item.availability === 'Unavailable'}">
                  {{ item.availability }}
                </span>
                <button
                  class="book-btn"
                  (click)="bookSlot(item)"
                  [disabled]="item.availability === 'Unavailable'"
                  [title]="item.availability === 'Unavailable' ? 'This lawyer is currently unavailable' : 'Book an appointment'"
                  [attr.data-tooltip]="item.availability === 'Unavailable' ? 'This lawyer is currently unavailable' : ''">
                  Book Appointment
                </button>
              </div>
            </div>
          </ng-template>

        </ng-container>

        <!-- No Results -->
        <div *ngIf="lawyers.length === 0" style="text-align: center; padding: 40px; color: #666;">
          <i class="bi bi-search" style="font-size: 48px; display: block; margin-bottom: 16px;"></i>
          <h3>No results found matching your criteria</h3>
          <p>Try adjusting your filters or search terms</p>
          <button class="clear-filters" (click)="onClearFilters()" style="margin-top: 20px;">Clear All Filters</button>
        </div>
        </ng-container>
      </section>

      <div class="nav-buttons" *ngIf="!isLoading && lawyers.length > 0">
        <button class="prev" (click)="prev()" [disabled]="!relPrevCursor"><< Prev</button>
        <button class="next" (click)="next()" [disabled]="!relNextCursor">Next >></button>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<footer>
  <div class="footer-container">
    <div class="footer-bottom">
      <a  alt="terms of service"
            href="https://digicoffer.com/digicoffer_terms.pdf">Terms of Service</a>
      <span>|</span>
      <a alt="privacy policy" href="https://digicoffer.com/digicoffer_privacy.pdf">Privacy Policy</a>
      <span>|</span>
      <a href="https://digicoffer.com/digicoffer_cookie.pdf">Cookie Policy</a>
    </div>
    <div class="footer-credit">
      © {{ currentYear }} Lex-Z. All rights reserved.
    </div>
  </div>
</footer>



<!-- Subscription Inactive Popup -->
<div class="popup-overlay" *ngIf="showSubscriptionPopup">

  <div class="popup-card">
    <button class="close-btn" (click)="closeSubscriptionPopup()">✕</button>
    
    <h2>Get Started</h2>

    <p class="subtitle">Fill in your details and we'll help you find the right lawyer</p>

    <form #leadFormRef="ngForm" (ngSubmit)="submitSubscriptionRequest(leadFormRef)">
    
      <div class="form-grid">
    
        <div class="left-column">
          <div class="form-group">
            <label>Name <span>*</span></label>
            <input type="text" name="name" [(ngModel)]="leadForm.name" #name="ngModel" required minlength="3" placeholder="Enter your name">
            <small class="error" *ngIf="name.invalid && name.touched">
              <span *ngIf="name.errors?.['required']">Name is required</span>
              <span *ngIf="name.errors?.['minlength']">Minimum 3 characters required</span>
            </small>
          </div>
    
          <div class="form-group">
            <label>Email <span>*</span></label>
            <input type="email" name="email" [(ngModel)]="leadForm.email" #email="ngModel" required email placeholder="Enter your email">
            <small class="error" *ngIf="email.invalid && email.touched">
              <span *ngIf="email.errors?.['required']">Email is required</span>
              <span *ngIf="email.errors?.['email']">Enter a valid email address</span>
            </small>
          </div>
    
          <div class="form-group">
            <label>Mobile <span>*</span></label>
            <input type="text" name="mobile" [(ngModel)]="leadForm.mobile" #mobile="ngModel" required pattern="^[0-9]{10}$" maxlength="10" placeholder="Enter your 10-digit mobile number" (keypress)="allowOnlyNumbers($event)">
            <small class="error" *ngIf="mobile.invalid && mobile.touched">
              <span *ngIf="mobile.errors?.['required']"> Mobile number is required</span>
              <span *ngIf="mobile.errors?.['pattern']">Mobile number must contain exactly 10 digits</span>
            </small>
          </div>
        </div>
    
        <div class="right-column">
          <div class="form-group">
            <label>Location <span>*</span></label>
            <input type="text" name="location" [(ngModel)]="leadForm.location" #location="ngModel" required placeholder="Select your city">
            <small class="error" *ngIf="location.invalid && location.touched">Location is required</small>
          </div>
    
          <div class="form-group">
            <label>Issue Description <span>*</span></label>
            <textarea rows="5" maxlength="500" name="issueDescription" [(ngModel)]="leadForm.issueDescription"
              #issueDescription="ngModel" (keydown)="preventLeadingSpace($event)" required placeholder="Briefly describe your legal issue...">
            </textarea>
    
            <small class="error" *ngIf="issueDescription.invalid && issueDescription.touched">
              <span *ngIf="issueDescription.errors?.['required']">Please describe your legal issue</span>
            </small>
    
            <div class="counter">{{ leadForm.issueDescription.length }}/700</div>
          </div>
        </div>
    
      </div>
    
      <button type="submit" class="submit-btn" [disabled]="isSubmittingLead">
        {{ isSubmittingLead ? 'Submitting...' : 'Submit' }}
      </button>
    
    </form>

  </div>

</div>

<!-- Success Popup -->
<div class="success-overlay" *ngIf="showSuccessPopup">

  <div class="success-card">
    <div class="success-icon"><i class="bi bi-check-lg"></i></div>
    <h2>Thank You!</h2>
    <p>{{ successMessage }}</p>
    <button class="success-btn" (click)="closeSuccessPopup()">Got it</button>
  </div>

</div>